import { render, staticRenderFns } from "./ImportPersonalAccountWizard.vue?vue&type=template&id=053583f2&scoped=true&"
import script from "./ImportPersonalAccountWizard.vue?vue&type=script&lang=ts&"
export * from "./ImportPersonalAccountWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ImportPersonalAccountWizard.vue?vue&type=style&index=0&id=053583f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053583f2",
  null
  
)

export default component.exports